import TotalUsageSelector from "@components/common/TotalUsageSelector";
import ModalAlert from "@components/Modals/ModalAlert";
import { ModalConfirmationRebootTerminal } from "@components/Modals/ModalConfirmationRebootTerminal";
import { useIsDesktop, useIsMobile } from "@components/mediaQuery/useIsMobile";
import StarlinkMetricChart from "@components/vessels/Monitoring/StarlinkMetricChart.jsx";
import { fetchStarlinkDetails } from "@services/vesselService";
import { checkPermission } from "@utils/permissions";
import { telemetryMapper } from "@utils/telemetry.js";
import { memo, Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertStarlink from "../../alerts/AlertStarlink";
import ColumnChart from "../../charts/ColumnChart";
import CreditLimitDonutChart from "../../charts/CreditLimitDonutChart";
import DonutChart from "../../charts/DonutChart";
import CustomAccordion from "../../common/CustomAccordion";

const Starlink = () => {
	const [rebootModalData, setRebootModalData] = useState({
		open: false,
		kitId: null,
		kitNumber: null,
	});

	const [alertData, setAlertData] = useState({
		open: false,
		type: "success",
		message: "",
		timeout: 1000,
	});

	const showAlert = (type, message, timeout = 1000) => {
		setAlertData({
			open: true,
			type,
			message,
			timeout,
		});
	};

	const [isCurrentMonthSelected, setIsCurrentMonthSelected] = useState(true);
	const hasStarlink = useSelector((state) => state.modules.vessels?.starlink?.hasStarlink);
	const starlinkUsage = useSelector((state) => state.modules.vessels?.starlink?.starlinkUsage);
	const starlinkTelemetry = useSelector(
		(state) => state.modules.vessels?.starlink?.starlinkTelemetry,
	);

	const vesselDetails = useSelector((state) => state.modules.vessels?.vesselDetails?.starlinks);
	const id = useSelector((state) => state.modules.vessels.vesselDetails?.id);
	const loadingVesselDetailsStarlink = useSelector(
		(state) => state.modules.vessels?.starlink?.loadingVesselDetailsStarlink,
	);

	const selectedVessel = useSelector((state) => state.modules.vessels?.selectedVessel.id);

	const { token, permissions } = useSelector((state) => state.auth.user);

	const vesselSiteManagement = permissions.find(
		(resource) => resource.resource_name === "vessels_site",
	);
	const vesselStarlinks = vesselSiteManagement?.providers?.find(
		(subResource) => subResource.sub_resource_name === "starlink",
	);
	const authorizedPermissions = vesselStarlinks?.permissions?.filter(
		(permission) => permission.authorized === true,
	);
	const canViewKitDetails = authorizedPermissions?.some(
		(permission) => permission.name === "view kit details",
	);
	const canRebootTerminal = authorizedPermissions?.some(
		(permission) => permission.name === "reboot terminal",
	);

	const vesselmodules = vesselSiteManagement?.providers?.find(
		(subResource) => subResource.sub_resource_name === "modules",
	);
	const authorizedPermissionsModules = vesselmodules?.permissions?.filter(
		(permission) => permission.authorized === true,
	);

	const canViewActivationProv = checkPermission(
		authorizedPermissionsModules,
		"view activation prov",
	);
	const vesselData = useSelector((state) => state.modules.vessels?.vesselDetails);
	const isNicknameVisible = vesselData?.business_unit?.name === "IEC TELECOM NORWAY";

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [openAccordions, setOpenAccordions] = useState({
		totalUsageStarlink: true,
		starlinkUsage: true,
		starlinkAlert: true,
		starlinkTelemetry: true,
	});
	useEffect(() => {
		const initialOpenState = openAccordions;
		starlinkUsage.forEach((_, index) => {
			initialOpenState[`st-usage-${index}`] = true;
		});

		starlinkTelemetry.forEach((TelemetryData) => {
			initialOpenState[`${TelemetryData.label}`] = true;
		});
		if (vesselDetails) {
			vesselDetails.forEach((_, index) => {
				initialOpenState[`usage-${index}`] = true;
				initialOpenState[`credit-${index}`] = true;
			});

			vesselDetails.forEach((_, index) => {
				initialOpenState[index] = true;
			});
		}

		setOpenAccordions(initialOpenState);
	}, [starlinkUsage, starlinkTelemetry, vesselDetails]);
	const toggleAccordion = (id) => {
		setOpenAccordions((prevState) => ({
			...prevState,
			[id]: !prevState[id],
		}));
	};

	// setIsLoading(true);
	// fetchGraphTelemetry(token, id, range, type, device_id, dispatch, navigate);

	const currentLocalMonth = new Date().getMonth() + 1;
	const previousLocalMonth = currentLocalMonth === 1 ? 12 : currentLocalMonth - 1;

	const currentUtcMonth = new Date().getUTCMonth() + 1;
	let previousUtcMonth = currentUtcMonth === 1 ? 12 : currentUtcMonth - 1;

	const onActivateSetup = (kitId) => {
		const url = `/vessel/${selectedVessel}/${kitId}`;
		navigate(url);
	};
	const rebootStarlink = (kitId, kitNumber) => {
		setRebootModalData({
			open: true,
			kitId,
			kitNumber,
		});
	};

	const isMobile = useIsMobile();
	const isDesktop = useIsDesktop();
	const now = new Date();

	const currentUtcYear = now.getUTCFullYear();

	const previousYear = currentUtcMonth === 1 ? currentUtcYear - 1 : currentUtcYear;

	return (
		<div>
			{loadingVesselDetailsStarlink ? (
				<div className="flex h-64 items-center justify-center">
					<div className="h-32 w-32 animate-spin rounded-full border-custom-border border-t-2 border-b-2"></div>
				</div>
			) : hasStarlink ? (
				<div className="grid grid-cols-1 gap-4 md:grid-cols-1">
					{vesselDetails &&
						vesselDetails?.map((usageData, index) => (
							<CustomAccordion
								title={
									<>
										{usageData.kit_number}
										{isNicknameVisible && usageData?.kit_nickname && (
											<span className="text-gray-400 text-xs sm:text-sm">
												{" "}
												: {usageData.kit_nickname}
											</span>
										)}
									</>
								}
								// id="totalUsageStarlink"
								// isOpen={openAccordions.totalUsageStarlink}
								// toggleAccordion={() => toggleAccordion(`totalUsageStarlink`)}
								// classCss={`${openAccordions[`totalUsageStarlink`] && "bg-[#1F2A37]"} border-0`}
								onActivateSetup={() => {
									onActivateSetup(usageData.id);
								}}
								rebootStarlink={() => {
									rebootStarlink(usageData.id, usageData.kit_number);
								}}
								showButtonSetup={canViewKitDetails}
								id={`${usageData.kit_number}`}
								isOpen={openAccordions[`${usageData.kit_number}`]}
								toggleAccordion={() => toggleAccordion(`${usageData.kit_number}`)}
								classCss={`${openAccordions[`${usageData.kit_number}`] && "bg-[#1F2A37]"} border-0`}
								canViewActivationProv={canViewActivationProv}
								canRebootTerminal={canRebootTerminal}
								isMobile={isMobile}
							>
								<div className="" key={index}>
									<TotalUsageSelector
										key={index}
										usageData={usageData}
										currentUtcMonth={currentUtcMonth}
										previousUtcMonth={previousUtcMonth}
										index={index}
										currentUtcYear={currentUtcYear}
									/>

									<div
										key={index}
										className={`chart-row-Telemetry mb-4 grid gap-4 ${
											isDesktop ? "grid-cols-2" : "grid-cols-1"
										}`}
									>
										{usageData?.is_scap !== true && (
											<div
												className={`chart-column first-column border-[#272b49c5] border-t-2 border-solid ${openAccordions[`usage-${index}`] ? "bg-navbar-bg" : ""} rounded-lg border-t-0`}
											>
												<div className="mt-2 text-start font-bold text-white text-xs uppercase first:rounded-t-lg last:rounded-b-lg sm:text-sm md:text-base lg:text-lg">
													{`Starlink Usage - ${usageData?.service_line_number}`}
												</div>
												<div className="mt-2">
													<DonutChart
														setIsCurrentMonthSelected={setIsCurrentMonthSelected}
														//usageThisMonth={usageData.usage_this_month}
														usageThisMonth={
															usageData?.subscriptions &&
															usageData?.subscriptions.find(
																(sub) =>
																	Number(sub?.month) === Number(currentUtcMonth) &&
																	Number(sub?.year) === Number(currentUtcYear),
															)?.usage
														}
														// allowanceThisMonth={
														//   usageData?.this_month_subscription?.allowance_gb
														// }
														allowanceThisMonth={
															usageData?.subscriptions &&
															(() => {
																const sub = usageData.subscriptions.find(
																	(sub) =>
																		Number(sub?.month) === Number(currentUtcMonth) &&
																		Number(sub?.year) === Number(currentUtcYear),
																);

																if (!sub) return null;

																if (
																	usageData?.block_product === 1 &&
																	sub?.subscription &&
																	sub.subscription.allowance_gb
																) {
																	//return sub?.allowance_gb;
																	return sub.subscription.allowance_gb;
																} else if (sub?.subscription && sub.subscription.allowance_gb) {
																	return sub.subscription.allowance_gb;
																}

																return null;
															})()
														}
														allowancePreviousMonth={
															usageData?.subscriptions &&
															(() => {
																const sub = usageData.subscriptions.find(
																	(sub) =>
																		Number(sub?.month) === Number(previousUtcMonth) &&
																		Number(sub?.year) === Number(previousYear),
																);

																if (!sub) return null;

																if (
																	usageData?.block_product === 1 &&
																	sub?.subscription &&
																	sub.subscription.allowance_gb
																) {
																	return sub.subscription.allowance_gb;
																} else if (sub?.subscription && sub.subscription.allowance_gb) {
																	return sub.subscription.allowance_gb;
																}

																return null;
															})()
														}
														previousMonth={
															usageData?.subscriptions &&
															usageData?.subscriptions.find(
																(sub) =>
																	Number(sub?.month) === Number(previousUtcMonth) &&
																	Number(sub?.year) === Number(previousYear),
															)?.usage
														}
														// totalUsageThisMonth={usageData.total_usage_this_month}
														totalUsageThisMonth={
															usageData?.subscriptions &&
															usageData?.subscriptions.find(
																(sub) =>
																	Number(sub?.month) === Number(previousUtcMonth) &&
																	Number(sub?.year) === Number(previousYear),
															)?.total_usage
														}
														// totalUsagePreviousMonth={
														//   usageData.total_usage_previous_month
														// }
														totalUsagePreviousMonth={
															usageData?.subscriptions &&
															usageData?.subscriptions.find(
																(sub) =>
																	Number(sub?.month) === Number(currentUtcMonth) &&
																	Number(sub?.year) === Number(currentUtcYear),
															)?.total_usage
														}
														// alerts={usageData.credit_limit && usageData?.credit_limit !== null ? usageData?.credit_limit?.alerts?.filter(
														//   (alert) => alert.bundle_type === "IN_BUNDLE"
														// ) : []}

														alerts={
															(usageData?.subscriptions &&
																usageData?.subscriptions.find(
																	(sub) =>
																		Number(sub?.month) === Number(currentUtcMonth) &&
																		Number(sub?.year) === Number(currentUtcYear),
																)?.in_bundle_alerts) ||
															[]
														}
														alertspreviousmonth={
															usageData?.subscriptions?.find(
																(sub) =>
																	Number(sub?.month) === Number(previousUtcMonth) &&
																	Number(sub?.year) === Number(previousYear),
															)?.in_bundle_alerts || []
														}
														totalStandard={parseFloat(
															usageData?.subscriptions.find(
																(sub) =>
																	Number(sub?.month) === Number(currentUtcMonth) &&
																	Number(sub?.year) === Number(currentUtcYear),
															)?.total_standard ?? 0,
														).toFixed(2)}
														totalStandardPreviousMonth={parseFloat(
															usageData?.subscriptions.find(
																(sub) =>
																	Number(sub?.month) === Number(previousUtcMonth) &&
																	Number(sub?.year) === Number(previousYear),
															)?.total_standard ?? 0,
														).toFixed(2)}
													/>
												</div>
											</div>
										)}

										{usageData?.is_scap !== true && (
											<div
												className={`chart-column first-column border-[#272b49c5] border-t-2 border-solid ${openAccordions[`credit-${index}`] ? "bg-navbar-bg" : ""} rounded-lg border-t-0`}
											>
												<div className="mt-2 text-start font-bold text-white text-xs uppercase first:rounded-t-lg last:rounded-b-lg sm:text-sm md:text-base lg:text-lg">
													{`STARLINK CREDIT LIMIT - ${usageData?.service_line_number}`}
												</div>

												{usageData?.credit_limit === null ? (
													<div className="flex h-64 items-center justify-center">
														<span className="font-normal text-gray-400 text-sm leading-tight">
															No Credit Limit
														</span>
													</div>
												) : (
													<div className="mt-2">
														<div className="mt-2">
															{(() => {
																const subForCurrentMonth = usageData?.subscriptions?.find(
																	(sub) =>
																		Number(sub?.month) === Number(currentUtcMonth) &&
																		Number(sub?.year) === Number(currentUtcYear),
																);

																const isUnlimited =
																	usageData?.credit_limit?.current_month_option === "UNLIMITED" ||
																	subForCurrentMonth?.subscription?.allowance_gb === "UNLIMITED";

																const targetMonth = isCurrentMonthSelected
																	? currentUtcMonth
																	: previousUtcMonth;
																const targetYear = isCurrentMonthSelected
																	? currentUtcYear
																	: previousYear;

																const creditLimitForTarget = usageData?.credit_limits?.find(
																	(c) =>
																		Number(c?.month) === Number(targetMonth) &&
																		Number(c?.year) === Number(targetYear),
																);

																const fallbackCreditLimit = usageData?.credit_limit;

																const chartProps = {
																	typeoptin: isUnlimited
																		? "UNLIMITED"
																		: (creditLimitForTarget?.current_month_option ??
																			fallbackCreditLimit?.current_month_option),

																	allowanceValue: isUnlimited
																		? 100
																		: (creditLimitForTarget?.current_month_value ??
																			fallbackCreditLimit?.current_month_value),

																	allowanceCurrentValue: isUnlimited
																		? 100
																		: (creditLimitForTarget?.current_month_usage_value ??
																			fallbackCreditLimit?.current_month_usage_value),

																	alerts:
																		creditLimitForTarget?.out_bundle_alerts ??
																		(fallbackCreditLimit?.out_bundle_alerts || []),
																};

																return (
																	<CreditLimitDonutChart
																		id={`credit_limit-${index}`}
																		{...chartProps}
																		lengthalerts={1}
																		totalUsageThisMonth={usageData?.total_usage_this_month}
																		unlimitedValue={
																			usageData?.this_month_subscription?.allowance_gb -
																			usageData.total_usage_this_month
																		}
																		kitNumber={usageData?.kit_number}
																		histories={usageData?.credit_limit_historics}
																		vesselid={id}
																		usageData={usageData}
																		token={token}
																		navigate={navigate}
																		dispatch={dispatch}
																		kitdata={usageData}
																	/>
																);
															})()}
														</div>
													</div>
												)}
											</div>
										)}
									</div>

									{usageData?.subscriptions &&
										usageData?.subscriptions.find(
											(sub) =>
												Number(sub?.month) === Number(currentUtcMonth) &&
												Number(sub?.year) === Number(currentUtcYear),
										)?.subscription?.allowance_gb === "UNLIMITED" && (
											<div>
												<div className="my-3 flex w-full items-start space-x-3 rounded-lg border-yellow-500 border-l-4 bg-yellow-100 p-4 shadow-lg">
													<div className="flex items-center justify-center rounded-full p-2 text-white">
														<svg
															className="h-6 w-6 text-yellow-500"
															xmlns="http://www.w3.org/2000/svg"
															fill="currentColor"
															viewBox="0 0 24 24"
														>
															<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
														</svg>
													</div>
													<div className="text-yellow-900">
														<p className="flex items-center space-x-2 font-semibold text-yellow-800">
															<span>Kit Suspension Notice</span>
														</p>
														<p className="text-sm">
															Your kit is currently{" "}
															<strong>
																{" "}
																{usageData.optin_starlink === 1 ? "Unsuspended" : "Suspended"}
															</strong>
															. You can{" "}
															<a
																// href={`/vessel/${usageData.id}/${usageData.kit_number}`}
																className="cursor-pointer text-yellow-600 underline hover:text-blue-800"
																onClick={async () => {
																	const url = `/vessel/${selectedVessel}/${usageData.id}?suspendaction=true`;
																	await fetchStarlinkDetails(
																		usageData.id,
																		usageData.kit_number,
																		token,
																		dispatch,
																		navigate,
																		url,
																	);
																	navigate(url); // navigate only after data is fetched
																}}
															>
																{usageData.optin_starlink === 1 ? "Suspend" : "Unsuspend"} it here
															</a>
															.
														</p>
													</div>
												</div>
											</div>
										)}
								</div>
								{starlinkUsage &&
									starlinkUsage.filter((usage) => usage.kit_number === usageData.kit_number)
										.length > 0 &&
									starlinkUsage
										.filter((usageKit) => usageKit.kit_number === usageData.kit_number)
										.map((usageKit, index) => (
											<div key={index} className="">
												<div
													className={`chart-column first-column border-[#272b49c5] border-t-2 border-solid ${openAccordions[`st-usage-${index}`] ? "bg-navbar-bg" : ""} rounded-lg border-t-0`}
												>
													<div className="mt-2 text-start font-bold text-xs uppercase sm:text-sm md:text-base lg:text-lg">
														{`Starlink Usage  - ${usageKit.service_line_number}`}
													</div>

													{usageKit?.data?.results?.[0]?.billingCycles?.length > 0 ? (
														<div className="mt-2">
															<ColumnChart
																billingCycles={usageKit?.data?.results[0]?.billingCycles}
																kit_number={usageKit.kit_number}
															/>
														</div>
													) : (
														<span className="flex h-8 w-full items-center justify-center text-gray-400 text-sm">
															No data
														</span>
													)}
													{/* </CustomAccordion> */}
												</div>
											</div>
										))}

								<div key={index}>
									<div className="mt-2 flex items-center py-3 text-start font-bold text-xs uppercase sm:text-sm md:text-base lg:text-lg">
										{`STARLINK ALERT - ${usageData?.service_line_number}`}
									</div>
									<div className="mt-2">
										<AlertStarlink kit_number={usageData?.kit_number} />
									</div>
								</div>

								<TelemetryGrid
									starlinkTelemetry={starlinkTelemetry}
									vesselDetails={vesselDetails}
									usageData={usageData}
									telemetryMapper={telemetryMapper}
									isDesktop={isDesktop}
									openAccordions={openAccordions}
									dispatch={dispatch}
									navigate={navigate}
									token={token}
								/>
							</CustomAccordion>
						))}
				</div>
			) : (
				<div className="flex h-64 items-center justify-center">
					<span className="font-normal text-gray-400 text-sm leading-tight">
						No Active Starlink KIT
					</span>
				</div>
			)}

			{rebootModalData.open && (
				<Suspense fallback={<div />}>
					<ModalConfirmationRebootTerminal
						isOpen={rebootModalData.open}
						closeModal={() =>
							setRebootModalData({
								open: false,
								kitId: null,
								kitNumber: null,
							})
						}
						kitId={rebootModalData.kitId}
						kitNumber={rebootModalData.kitNumber}
						token={token}
						showAlert={showAlert}
					/>
				</Suspense>
			)}

			<ModalAlert
				isOpen={alertData.open}
				type={alertData.type}
				message={alertData.message}
				timeout={alertData.timeout}
				closeModal={() =>
					setAlertData((prev) => ({
						...prev,
						open: false,
					}))
				}
			/>
		</div>
	);
};

const TelemetryGrid = memo(function TelemetryGrid({
	starlinkTelemetry,
	vesselDetails,
	usageData,
	telemetryMapper,
	isDesktop,
	openAccordions,
	dispatch,
	navigate,
	token,
}) {
	return starlinkTelemetry.reduce((rows, TelemetryData, index) => {
		const vesselDetail = vesselDetails?.find(
			(vessel) =>
				vessel?.id === TelemetryData?.id && usageData.device_id === TelemetryData.device_id,
		);

		if (vesselDetail) {
			const accountNumber = vesselDetail?.acccount_number?.number;

			const { metric, label, unit, multiplier } = telemetryMapper[TelemetryData?.type];
			if (index % 2 === 0) {
				const nextTelemetry = starlinkTelemetry[index + 1];
				const nextMapper = nextTelemetry ? telemetryMapper[nextTelemetry?.type] : null;
				rows.push(
					<div
						key={index}
						className={`chart-row-Telemetry grid gap-4 border-[#272b49c5] border-b-2 border-solid ${
							isDesktop ? "grid-cols-2" : "grid-cols-1"
						}`}
					>
						{/* First column */}

						<div
							className={`chart-column w-50 ${openAccordions[`${TelemetryData?.label}-${index}`] ? "bg-navbar-bg" : ""} rounded-lg border-t-0`}
						>
							<div className="mt-2 border-[#272b49c5] border-b-2 border-solid">
								<StarlinkMetricChart
									title={TelemetryData?.label}
									metricType={metric}
									label={label}
									unit={unit}
									multiplier={multiplier}
									deviceId={vesselDetail?.device_id}
									accountNumber={accountNumber}
								/>
							</div>
							{/* </CustomAccordion> */}
						</div>
						{/* Second column */}
						{starlinkTelemetry[index + 1] && (
							<div
								className={`chart-column w-50 ${openAccordions[`${starlinkTelemetry[index + 1].label}`] ? "bg-navbar-bg" : ""} rounded-lg border-t-0`}
							>
								<div className="mt-2 border-[#272b49c5] border-b-2 border-solid">
									<StarlinkMetricChart
										title={nextTelemetry?.label}
										metricType={nextMapper.metric}
										label={nextMapper.label}
										unit={nextMapper.unit}
										multiplier={nextMapper.multiplier}
										deviceId={vesselDetail?.device_id}
										accountNumber={accountNumber}
									/>
								</div>

								{/* </CustomAccordion> */}
							</div>
						)}
					</div>,
				);
			}
		}
		return rows;
	}, []);
});

export default Starlink;
